import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  REGISTER,
  PURGE,
  PERSIST,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './auth/auth-slice';
import HomeReducer from './home/home-slice';
import adminReducer from './admin/admin-slice';
import userReducer from './user/user-slice';
import optionsReducer from './options/options-slice';

const middleware = [
  ...getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }),
];

const authPersistConfig = {
  key: 'auth',
  storage,
  whitelist: ['token'],
};

export const store = configureStore({
  reducer: {
    home: HomeReducer,
    admin: adminReducer,
    options: optionsReducer,
    auth: persistReducer(authPersistConfig, authReducer),
    user: userReducer,
  },

  middleware,
  devTools: process.env.NODE_ENV === 'development',
});
export const persistor = persistStore(store);
